



import { useState } from "react";
import { HiArrowRightOnRectangle } from "react-icons/hi2";
import ButtonIcon from "../../ui/ButtonIcon";
import { useLogout } from "./useLogout";
import SpinnerMini from "../../ui/SpinnerMini";

// Simple modal component (feel free to replace with your own)
function ConfirmModal({ onConfirm, onCancel }) {
    return (
        <div className="fixed inset-0 bg-black/30 backdrop-blur-md flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow p-6 w-full max-w-sm text-center">
                <p className="mb-4 text-lg font-semibold">Are you sure you want to log out?</p>
                <div className="flex justify-center gap-4">
                    <button
                        className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                        onClick={onConfirm}
                    >
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
}

function Logout() {
    const { logout, isLoading } = useLogout();
    const [showConfirm, setShowConfirm] = useState(false);

    const handleLogoutClick = () => setShowConfirm(true);
    const handleCancel = () => setShowConfirm(false);
    const handleConfirm = () => {
        setShowConfirm(false);
        logout();
    };

    return (
        <>
            <span
              onClick={handleLogoutClick}
              className="flex items-center gap-3 px-4 py-2 hover:bg-pink-100 w-full text-gray-700 cursor-pointer">
                <HiArrowRightOnRectangle className="text-pink-500 text-lg"/>
                Logout
            </span>

            {showConfirm && (
                <ConfirmModal
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                />
            )}
        </>
    );
}

export default Logout;
